import pagesAuthInvitationEn from "./invitation/default";

const pagesAuthEn = {
  common: {
    quote:
      "DRESS CODE works for workforce, product value and deal of your organization. Lead to workforce optimization.",
    email: "Email",
    password: "Password",
    termOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
  },
  /**
   * @note Since we use amplify instead of the dresscode-backend server,
   * we cannot use the handling specified in lib/api/error.ts, so we define auth error messages as an exception
   */
  unknownError: "An error occurred",
  signIn: {
    pageTitle: "Sign in to DRESS CODE",
    title: "Sign In",
    description:
      "Organize every workflow so that anyone can execute them comfortably and naturally.",
    instruction: "Enter your Email and password to sign in",
    warning:
      "By clicking continue, you agree to our\n<termsOfUseLink>Terms of Service</termsOfUseLink> and <privacyPolicyLink>Privacy Policy</privacyPolicyLink>.",
    invalidEmailPasswordError: "Invalid username or password",
    tooManyAttemptsError: "Too many attempts. Please try again later.",
    submitButton: "Sign In",
    forgotPassword: "Forgot password?",
  },
  request: {
    pageTitle: "Request reset password",
    title: "Reset your password",
    instruction: "Enter your Email to reset your password",
    successfulMessage: "Password reset request successful.",
    incorrectEmailError: "Email is incorrect.",
    submitButton: "Reset Password",
  },
  reset: {
    pageTitle: "Request reset password",
    requestVerify: {
      title: "Forgot Password?",
      description:
        "Enter your email address and we'll send you a verification code to reset your password.",
      backToSignIn: "Back to <Link to='/auth' className=''>Sign in</Link>",
      email: "Email",
      sendButton: "Send",
      limitExceededError:
        "The reset password limit has been exceeded. Please try again later.",
      userNotFoundError: "User not found.",
      successMessage: "Password reset email has been sent",
      successDescription:
        "If you don't receive the email, the user may not be registered or not yet verified. Please contact your administrator.",
    },
    resetPassword: {
      title: "Verify Your Account",
      verificationCode: "Verification Code",
      verificationCodeDescription:
        "Enter the verification code that was sent to your email.",
      newPassword: "New Password",
      newPasswordDescription: "Enter the new password to change your password.",
      newPasswordPlaceholder: "password",
      showPassword: "Show password",
      verifyButton: "Verify",
      didNotReceiveCode: "Didn't get email?",
      resendCode: "Resend Code",
      codeMismatchError: "The verification code is incorrect.",
      invalidPasswordError:
        "Use a password at least 10 characters long with alphanumeric characters (including upper and lower case letters) and symbols.",
      limitExceededError:
        "The reset password limit has been exceeded. Please try again later.",
      successMessage:
        "Your password was reset successfully. You are now signed in.",
    },
  },
  mfa: {
    email: {
      title: "Check Your Email",
      notReceivedCode: "Didn't receive an email? ",
    },
    resendSignInCode: {
      successResendSignInCodeMessage: "Authentication code resent.",
      successResendSignInCodeDescription: "Check your email for the new code.",
      errorResendSignInCodeMessage: "Failed to resend authentication code.",
      errorResendSignInCodeDescription: "Please try again.",
    },
    description: "Enter the six digit-code",
    codeLabel: "Authentication code",
    instruction: "Enter the code displayed in the authentication app",
    label: "mfa",
    error: {
      invalid: "The authentication code is incorrect.",
      expired: "The authentication code has expired.",
      codeDeliveryFailure: "Failed to send verification code.",
    },
    submitButton: "Verify",
    resendLink: "Resend",
  },
  invitation: pagesAuthInvitationEn,
  /**
   * Ory Kratos 認証フロー用の翻訳キー
   * meta.label.id から翻訳を取得する際に使用
   *
   * Ory KratosのIDベースの翻訳:
   * - 数値ID（例: "1070002"）をキーとして使用
   * - 翻訳が見つからない場合は meta.label.text（Ory Kratosのデフォルトテキスト）を使用
   *
   * @see https://www.ory.com/docs/kratos/concepts/ui-user-interface#ui-message-codes
   */
  ory: {
    // Login (101xxxx)
    "1010001": "Sign in",
    "1010002": "Sign in with {provider}",
    "1010003": "Please confirm this action by verifying that it is you.",
    "1010004": "Please complete the second authentication challenge.",
    "1010005": "Verify",
    "1010006": "Authentication code",
    "1010007": "Backup recovery code",
    "1010008": "Sign in with hardware key",
    "1010009": "Use Authenticator",
    "1010010": "Use backup recovery code",
    "1010011": "Sign in with hardware key",
    "1010012":
      "Prepare your WebAuthn device (e.g. security key, biometrics scanner, ...) and press continue.",
    "1010013": "Continue",
    "1010014":
      "A code was sent to the address you provided. If you didn't receive it, please check the spelling of the address and try again.",
    "1010015": "Send sign in code",
    "1010016":
      'You tried to sign in with "{duplicateIdentifier}", but that email is already used by another account. Sign in to your account with one of the options below to add your account "{duplicateIdentifier}" at "{provider}" as another way to sign in.',
    "1010017": "Sign in and link",
    "1010018": "Confirm with {provider}",
    "1010019": "Request code to continue",
    "1010021": "Sign in with passkey",
    "1010022": "Sign in with password",
    "1010023": "Send code to {address}",
    // Registration (104xxxx)
    "1040001": "Sign up",
    "1040002": "Sign up with {provider}",
    "1040003": "Continue",
    "1040004": "Sign up with security key",
    "1040005":
      "A code has been sent to the address(es) you provided. If you have not received a message, check the spelling of the address and retry the registration.",
    "1040006": "Send sign up code",
    "1040007": "Sign up with passkey",
    "1040008": "Back",
    "1040009": "Please choose a credential to authenticate yourself with.",
    // Settings (105xxxx)
    "1050001": "Your changes have been saved!",
    "1050002": "Link {provider}",
    "1050003": "Unlink {provider}",
    "1050004": "Unlink TOTP Authenticator App",
    "1050005": "Authenticator app QR code",
    "1050006": "{secret}",
    "1050007": "Reveal backup recovery codes",
    "1050008": "Generate new backup recovery codes",
    "1050009": "{secret}",
    "1050010":
      "These are your back up recovery codes. Please keep them in a safe place!",
    "1050011": "Confirm backup recovery codes",
    "1050012": "Add security key",
    "1050013": "Name of the security key",
    "1050014": "Secret was used at {used_at}",
    "1050015": "{secrets_list}",
    "1050016": "Disable this method",
    "1050017":
      "This is your authenticator app secret. Use it if you can not scan the QR code.",
    "1050018": 'Remove security key "{display_name}"',
    "1050019": "Add passkey",
    "1050020": 'Remove passkey "{display_name}"',
    // Recovery (106xxxx)
    "1060001":
      "You successfully recovered your account. Please change your password or set up an alternative login method (e.g. social sign in) within the next 1.00 minutes.",
    "1060002":
      "An email containing a recovery link has been sent to the email address you provided. If you have not received an email, check the spelling of the address and make sure to use the address you registered with.",
    "1060003":
      "An email containing a recovery code has been sent to the email address you provided. If you have not received an email, check the spelling of the address and make sure to use the address you registered with.",
    "1060004":
      "A recovery code has been sent to {masked_address}. If you have not received it, check the spelling of the address and make sure to use the address you registered with.",
    "1060005":
      "Recover access to your account by providing your recovery address in full.",
    "1060006": "How do you want to recover your account?",
    "1060007": "Back",
    // Common UI (107xxxx)
    "1070001": "Password",
    "1070002": "{title}",
    "1070003": "Save",
    "1070004": "ID",
    "1070005": "Submit",
    "1070006": "Verify code",
    "1070007": "Email",
    "1070008": "Resend code",
    "1070009": "Continue",
    "1070010": "Recovery code",
    "1070011": "Verification code",
    "1070012": "Registration code",
    "1070013": "Login code",
    "1070014": "Login and link credential",
    "1070015": "Please complete the captcha challenge to continue.",
    "1070016": "Recovery address",
    "1070017": "Phone number",
    // Verification (108xxxx)
    "1080001":
      "An email containing a verification link has been sent to the email address you provided. If you have not received an email, check the spelling of the address and make sure to use the address you registered with.",
    "1080002": "You successfully verified your email address.",
    "1080003":
      "An email containing a verification code has been sent to the email address you provided. If you have not received an email, check the spelling of the address and make sure to use the address you registered with.",
    // Error Messages (400xxxx)
    "4000001": "{reason}",
    "4000002": "Property {property} is missing.",
    "4000003": "length must be >= {min_length}, but got {actual_length}",
    "4000004": 'does not match pattern "{pattern}"',
    "4000005": "The password can not be used because {reason}.",
    "4000006":
      "The provided credentials are invalid, check for spelling mistakes in your password or username, email address, or phone number.",
    "4000007":
      "An account with the same identifier (email, phone, username, ...) exists already.",
    "4000008": "The provided authentication code is invalid, please try again.",
    "4000009":
      "Could not find any login identifiers. Did you forget to set them? This could also be caused by a server misconfiguration.",
    "4000010":
      "Account not active yet. Did you forget to verify your email address?",
    "4000011": "You have no TOTP device set up.",
    "4000012": "This backup recovery code has already been used.",
    "4000013": "You have no WebAuthn device set up.",
    "4000014": "You have no backup recovery codes set up.",
    "4000015": "This account does not exist or has no security key set up.",
    "4000016": "The backup recovery code is not valid.",
    "4000017": "length must be <= {max_length}, but got {actual_length}",
    "4000018": "must be >= {minimum} but found {actual}",
    "4000019": "must be > {minimum} but found {actual}",
    "4000020": "must be <= {maximum} but found {actual}",
    "4000021": "must be < {maximum} but found {actual}",
    "4000022": "{actual} not multipleOf {base}",
    "4000023":
      "maximum {max_items} items allowed, but found {actual_items} items",
    "4000024":
      "minimum {min_items} items allowed, but found {actual_items} items",
    "4000025": "items at index {index_a} and {index_b} are equal",
    "4000026": "expected {allowed_types_list}, but got {actual_type}",
    "4000027":
      "An account with the same identifier (email, phone, username, ...) exists already. Please sign in to your existing account to link your social profile.",
    "4000028":
      "You tried signing in with {credential_identifier_hint} which is already in use by another account. You can sign in using {available_credential_types_list}. You can sign in using one of the following social sign in providers: {available_oidc_providers_list}.",
    "4000029": "must be equal to constant {expected}",
    "4000030": "const failed",
    "4000031":
      "The password can not be used because it is too similar to the identifier.",
    "4000032":
      "The password must be at least {min_length} characters long, but got {actual_length}.",
    "4000033":
      "The password must be at most {max_length} characters long, but got {actual_length}.",
    "4000034":
      "The password has been found in data breaches and must no longer be used.",
    "4000035":
      "This account does not exist or has not setup sign in with code.",
    "4000036":
      "The provided traits do not match the traits previously associated with this flow.",
    "4000037": "This account does not exist or has no login method configured.",
    "4000038": "Captcha verification failed, please try again.",
    "4000039": "The new password must be different from the old password.",
    // Login Errors (401xxxx)
    "4010001": "The login flow expired {expired_at} ago, please try again.",
    "4010002":
      "Could not find a strategy to log you in with. Did you fill out the form correctly?",
    "4010003":
      "Could not find a strategy to sign you up with. Did you fill out the form correctly?",
    "4010004":
      "Could not find a strategy to update your settings. Did you fill out the form correctly?",
    "4010005":
      "Could not find a strategy to recover your account with. Did you fill out the form correctly?",
    "4010006":
      "Could not find a strategy to verify your account with. Did you fill out the form correctly?",
    "4010007":
      "The request was already completed successfully and can not be retried.",
    "4010008":
      "The login code is invalid or has already been used. Please try again.",
    "4010009": "Linked credentials do not match.",
    "4010010":
      "The address you entered does not match any known addresses in the current account.",
    // Registration Errors (404xxxx)
    "4040001":
      "The registration flow expired {expired_at} ago, please try again.",
    "4040002":
      "The request was already completed successfully and can not be retried.",
    "4040003":
      "The registration code is invalid or has already been used. Please try again.",
    // Settings Errors (405xxxx)
    "4050001": "The settings flow expired {expired_at} ago, please try again.",
    // Recovery Errors (406xxxx)
    "4060001":
      "The request was already completed successfully and can not be retried.",
    "4060002": "The recovery flow reached a failure state and must be retried.",
    "4060004":
      "The recovery token is invalid or has already been used. Please retry the flow.",
    "4060005": "The recovery flow expired {expired_at} ago, please try again.",
    "4060006":
      "The recovery code is invalid or has already been used. Please try again.",
    // Verification Errors (407xxxx)
    "4070001":
      "The verification token is invalid or has already been used. Please retry the flow.",
    "4070002":
      "The request was already completed successfully and can not be retried.",
    "4070003":
      "The verification flow reached a failure state and must be retried.",
    "4070005":
      "The verification flow expired {expired_at} ago, please try again.",
    "4070006":
      "The verification code is invalid or has already been used. Please try again.",
    // System Errors (500xxxx)
    "5000001": "{reason}",
    // Ory Error IDs and Reasons
    error: {
      session_inactive: "Your session is inactive. Please sign in again.",
      session_aal2_required:
        "Step-up authentication (AAL2) is required to perform this action.",
      session_already_available:
        "You are already signed in. Redirecting to home page.",
      session_refresh_required:
        "The login session is too old and thus not allowed to update these fields. Please re-authenticate.",
      self_service_flow_return_to_forbidden:
        "The return_to address is not allowed.",
      self_service_flow_expired:
        "Your interaction expired, please fill out the form again.",
      security_csrf_violation:
        "A security violation was detected, please fill out the form again.",
      security_identity_mismatch:
        "The requested item was intended for someone else. Please start a new flow.",
      browser_location_change_required: "Redirecting to the required location.",
    },
  },
};

export default pagesAuthEn;
